export const sendMessage = (
  orderId: string,
  source: string,
  action: string,
) => {
  if (!mobileBridgeIsAvailable()) {
    return;
  }

  try {
    Mobile?.postMessage(
      JSON.stringify({
        payload: {
          source,
          order_id: orderId,
        },
        action,
      }),
    );
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    console.error("Failed to send mobile message.");
  }
};

const mobileBridgeIsAvailable = () => {
  try {
    return !!Mobile;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (err) {
    return false;
  }
};
